import React from 'react';
import { motion } from 'framer-motion';

export default function ReviewsSection({ reviews, onMessageWhatsApp }) {
  return (
    <section className="reviews" id="reviews">
      <div className="reviews-inner">
        <motion.div
          className="reviews-head"
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="reviews-kicker">Trusted by families</div>
          <h2>Our Reviews</h2>
          <p>
            Real messages and real moments. Browse highlights below — then message us anytime if you want help choosing
            the right pup.
          </p>
        </motion.div>

        <div className="reviews-grid">
          {reviews.map((item, idx) => (
            <motion.div
              key={item.src}
              className="review-card is-image"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: (idx % 6) * 0.03 }}
              whileHover={{ y: -6 }}
            >
              <div className="review-media">
                <img src={item.src} alt={item.title} loading="lazy" />
              </div>
              <div className="review-meta">
                <div className="review-title">{item.title}</div>
                <div className="review-caption">{item.caption}</div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="reviews-cta">
          <button className="reviews-cta-btn" type="button" onClick={onMessageWhatsApp}>
            Message us on WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
}

